import { useContext } from 'react';
import { PackingContext } from '../services/PackingContext';

export const usePackingContext = () => {
  const context = useContext(PackingContext);
  if (!context) {
    throw new Error('usePackingContext debe usarse dentro de PackingProvider');
  }
  return context;
};

// Re-exportar el tipo del contexto para que esté disponible
export type { PackingContextType } from '../services/PackingContext';
